import {
	IconArchive,
	IconCheck,
	IconGavel,
	IconRefresh,
	IconTrash,
	IconX,
} from "@tabler/icons-react";
import React from "react";

export function LexWorkplaceGavelIcon() {
	return <IconGavel size={16} style={{ verticalAlign: "sub" }} />;
}

export function LexWorkplaceXIcon() {
	return <IconX size={16} style={{ verticalAlign: "sub" }} />;
}

export function LexWorkplaceCheckIcon() {
	return <IconCheck size={16} style={{ verticalAlign: "sub" }} />;
}

export function LexWorkplaceRefreshIcon() {
	return <IconRefresh size={20} style={{ verticalAlign: "sub" }} />;
}

export function LexWorkplaceTrashIcon() {
	return <IconTrash size={20} style={{ verticalAlign: "sub" }} />;
}
export function LexWorkplaceArchiveIcon() {
	return <IconArchive size={20} style={{ verticalAlign: "sub" }} />;
}
